<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const SlotsIcon = getIcon("SlotsIcon");
</script>

{#if typeof SlotsIcon === 'string'}
	<img src={SlotsIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof SlotsIcon === 'function'}
	<svelte:component this={SlotsIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
